import { createServices } from 'services/services';
import { createUserPresenter } from 'stores/User/user_store';
import { createCommonPresenter } from './Main/common_store';
import { createUIPresenter } from './DisplaySetting/ui_store';
import { createChartPresenter } from './Main/chart_store';
import { createHomePresenter } from './Main/home_stores';
import { createSurveyPresenter } from './Survey/survey_store';
import { createLanguagePresenter } from './Language/language_store';
import { createZNSPresenter } from './ZNS/zns_store';
import { createProjectManagementPresenter } from './Main/projectManagement_store';
import { createReportWCPresenter } from './Main/reportWAndC_store';
import { createReportSavedPresenter } from './SaveRepoprtTemplete/reportSaved_store';
import { createCustomerSegmentPresenter } from './Main/customerSegment_store';
import { createEventCampaignPresenter } from './Main/eventCampaign_store';
import { createMarketingCampaignPresenter } from './Main/marketingCampaign_store';
import { createContactSegmentPresenter } from './Main/contactSegment_store';
import { createCriterialPresenter } from './Main/criterial_store';
import { createCampaignPresenter } from './Main/campaign_store';
import { createCustomerUnidentifiedPresenter } from './Main/customerUnidentified_store';
import { createReportVisitCustomerSRPresenter } from './Main/reportVisitCustomerSR';
import { createDocumentArchivePresenter } from './Main/documentArchive';
import { createWarrantyRemindPresenter } from './masterdata/warrantyRemind_store';
import { createExchangeRewardsPresenter } from './Main/exchangeRewards_store';
import { createUnfollowRemindPresenter } from './masterdata/unfollowRemind_store';
import { createCustomerGeneralReportPresenter } from './Main/customerGeneralReport_store';


// khởi tạo services
export const services = createServices();

// khởi tạo presenter và store của user
export const userPresenter = createUserPresenter(services);
export const userStore = userPresenter.createStore();

// khởi tạo presenter và store của user
export const uiPresenter = createUIPresenter();
export const uiStore = uiPresenter.createStore();

// khởi tạo presenter và store của language
export const languagePresenter = createLanguagePresenter(services);
export const languageStore = languagePresenter.createStore();

// khởi tạo presenter và store của Common
export const commonPresenter = createCommonPresenter(services);
export const commonStore = commonPresenter.createStore();

// khởi tạo presenter và store của Common
export const criterialPresenter = createCriterialPresenter(services);
export const criterialStore = criterialPresenter.createStore();

// khởi tạo presenter và store của Chart
export const chartPresenter = createChartPresenter(services);
export const chartStore = chartPresenter.createStore();

// khởi tạo presenter và store của Home
export const homePresenter = createHomePresenter(services);
export const homeStore = homePresenter.createStore();

// khởi tạo presenter và store của Quản lý dự án (project management)
export const projectManagementPresenter = createProjectManagementPresenter(services);
export const projectManagementStore = projectManagementPresenter.createStore();

// khởi tạo presenter và store của Báo cáo bảo hành - khiếu nại
export const reportWCPresenter = createReportWCPresenter(services);
export const reportWCStore = reportWCPresenter.createStore();

// khởi tạo presenter và store của customer segement
export const customerSegmentPresenter = createCustomerSegmentPresenter(services);
export const customerSegmentStore = customerSegmentPresenter.createStore();

// khởi tạo presenter và store của contact segement
export const contactSegmentPresenter = createContactSegmentPresenter(services);
export const contactSegmentStore = contactSegmentPresenter.createStore();

// khởi tạo presenter và store của customer segement
export const eventCampaignPresenter = createEventCampaignPresenter(services);
export const eventCampaignStore = eventCampaignPresenter.createStore();

// khởi tạo presenter và store của customer segement
export const marketingCampaignPresenter = createMarketingCampaignPresenter(services);
export const marketingCampaignStore = marketingCampaignPresenter.createStore();

// khởi tạo presenter và store của Campaign
export const campaignPresenter = createCampaignPresenter(services);
export const campaignStore = campaignPresenter.createStore();

// khởi tạo presenter và store của khách hành chưa định danh
export const customerUnindentifiedPresenter = createCustomerUnidentifiedPresenter(services);
export const customerUnindentifiedStore = customerUnindentifiedPresenter.createStore();




//========================================STORE DÙNG CHUNG===========================================================
// khởi tạo presenter và store của Survey
export const surveyPresenter = createSurveyPresenter(services);
export const surveyStore = surveyPresenter.createStore();

// khởi tạo presenter và store của zns
export const znsPresenter = createZNSPresenter(services);
export const znsStore = znsPresenter.createStore();

// Luu mau bao cao
export const reportSavedPresenter = createReportSavedPresenter(services);
export const reportSavedStore = reportSavedPresenter.createStore();

// Báo cáo ghé thăm khách hàng SR
export const reportVisitCustomerSRPresenter = createReportVisitCustomerSRPresenter(services);
export const reportVisitCustomerSRStore = reportVisitCustomerSRPresenter.createStore();

// Báo cáo ghé thăm khách hàng SR
export const documentArchivePresenter = createDocumentArchivePresenter(services);
export const documentArchiveStore = documentArchivePresenter.createStore();


// cấu hình thời gian nhắc nhở bảo hành
export const warrantyRemindPresenter = createWarrantyRemindPresenter(services);
export const warrantyRemindStore = warrantyRemindPresenter.createStore();

// bỏ theo dõi nhắc nhở bảo hành
export const unfollowRemindPresenter = createUnfollowRemindPresenter(services);
export const unfollowRemindStore = unfollowRemindPresenter.createStore();

// Tích điểm đổi quà
export const exchangeRewardsPresenter = createExchangeRewardsPresenter(services);
export const exchangeRewardsStore = exchangeRewardsPresenter.createStore();

export const customerGeneralReportPresenter = createCustomerGeneralReportPresenter(services);
export const customerGeneralReportStore = customerGeneralReportPresenter.createStore();